exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    background-color: #F0F0F0;\n    display: block;\n    /* height: 100px; */\n}\n.chnl-inv-hol-import-popup-wrapper {\n    padding: 15px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component.css
// module id = ../../../../../src/app/shared/lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component.css
// module chunks = main